import Img from "@casino/legacy/client/shared/images/Img";
import NextLink from "@casino/legacy/client/shared/NextLink";
import TextTrimmer from "@casino/legacy/client/shared/TextTrimmer";
import { cn } from "@workspace/frontend-ui";
import getProviderIcon from "./getProviderIcon";

type Props = { game?: GameFragment; isBetRangeVisible: boolean };

const GameProvider: FC<Props> = ({ game, isBetRangeVisible = false }) => {
  const provider = game?.menuItem?.[0];
  return (
    <NextLink
      href={`/providers/${provider?.handle}`}
      prefetch={false}
      className={cn(
        "z-1 absolute bottom-2 rtl:bottom-1 rtl:sm:bottom-2 left-2 sm:left-4 sm:max-md:bottom-4 lg:max-2xl:bottom-4 3xl:bottom-4 rtl:right-2 rtl:sm:right-4",
        isBetRangeVisible && "bottom-5 sm:bottom-5",
      )}
    >
      <div className="flex items-center gap-1 sm:gap-2">
        {provider?.handle && (
          <Img
            width={20}
            height={20}
            alt=""
            src={getProviderIcon(provider.handle)}
          />
        )}
        <TextTrimmer>
          <p className="text-xs text-white/70">{provider?.name ?? "\u00A0"}</p>
        </TextTrimmer>
      </div>
    </NextLink>
  );
};

export default GameProvider;
